var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.667 38.3892V69.3893C113.667 77.1393 111.083 83.5977 106.537 88.1443C102.042 92.6393 95.5832 95.2227 87.8332 95.2227V106.228C87.8332 110.361 83.2349 112.841 79.8249 110.568L56.8333 95.2227H45.8799C46.2933 93.6727 46.4999 92.071 46.4999 90.4177C46.4999 85.1477 44.4849 80.291 41.1782 76.6227C37.4582 72.386 31.9299 69.751 25.8333 69.751C20.0466 69.751 14.7766 72.1277 11.0049 76.0027C10.5399 73.936 10.3333 71.7143 10.3333 69.3893V38.3892C10.3333 22.8892 20.6666 12.5559 36.1666 12.5559H87.8332C103.333 12.5559 113.667 22.8892 113.667 38.3892Z",
    stroke: "#292D32",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5001 90.4167C46.5001 92.07 46.2934 93.6717 45.8801 95.2217C45.4151 97.2883 44.5885 99.3033 43.5035 101.06C39.9385 107.053 33.3767 111.083 25.8334 111.083C20.5117 111.083 15.7067 109.068 12.0901 105.762C10.5401 104.418 9.1967 102.817 8.16336 101.06C6.2517 97.96 5.16675 94.2917 5.16675 90.4167C5.16675 84.8367 7.38842 79.7217 11.0051 76.0017C14.7767 72.1267 20.0467 69.75 25.8334 69.75C31.9301 69.75 37.4584 72.385 41.1784 76.6217C44.4851 80.29 46.5001 85.1467 46.5001 90.4167Z",
    stroke: "#292D32",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3576 95.7908L20.4043 84.8892",
    stroke: "#292D32",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2567 85.0435L20.3035 95.9446",
    stroke: "#292D32",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9167 54.25H80.0834",
    stroke: "#292D32",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRemove);
export default __webpack_public_path__ + "static/media/message-remove.507e7aa4ef8fa2e20360af5f12f3a980.svg";
export { ForwardRef as ReactComponent };